module.exports = __webpack_public_path__ + "static/media/Lubros Picture.f33f3ae5.png";